import React, { createContext, useEffect, useState } from 'react';

import ToastNotification from '../../components/ToastNotification';
import { NotificationType } from '../../utils/types';

interface NotificationContextType {
  notificationData?: NotificationType;
  setNotificationData: Function;
}

export const CLEAR_NOTIFICATION_DELAY = 5000;

export const NotificationContext = createContext<NotificationContextType>({
  setNotificationData: () => {},
  notificationData: undefined,
});

type Props = {
  children: React.ReactNode;
};

export const NotificationContextContainer = (props: Props): JSX.Element => {
  const [showNotification, setShowNotification] = useState<boolean>(false);
  const [notificationData, setNotificationData] = useState<NotificationType>();
  const [viewedNotifications, setViewedNotifications] = useState<{
    [id: string]: boolean;
  }>({});
  const clearNotification = () => {
    setNotificationData(undefined);
    setShowNotification(false);
  };

  useEffect(() => {
    const id = notificationData?.id;
    if (id && !viewedNotifications[id]) {
      setShowNotification(true);
      if (notificationData?.onlyShowOnce) {
        setViewedNotifications({ ...viewedNotifications, [id]: true });
      }
      setTimeout(() => {
        clearNotification();
      }, CLEAR_NOTIFICATION_DELAY);
    }
  }, [notificationData]);

  return (
    <NotificationContext.Provider value={{ setNotificationData }}>
      {showNotification && (
        <ToastNotification
          notification={notificationData}
          clearNotification={clearNotification}
        />
      )}
      {props.children}
    </NotificationContext.Provider>
  );
};
